<div class="container">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <router-outlet></router-outlet>
</div>